/* eslint-disable eqeqeq */
<template lang="pug">
d2-container
  el-form(
    :inline="true",
    :model="dataForm",
    size="mini",
    label-position="right",
    label-width="75px",
    label-suffix=":"
  )
    el-row(:span="24")
      el-col(:md="6", :sm="12")
        el-form-item(label="比赛名称")
          el-input.sel-width(v-model="dataForm.matchName", clearable)
      el-col(:md="6", :sm="12")
        el-form-item(label="主办方")
          el-input.sel-width(v-model="dataForm.microOrgName", clearable)
      el-col(:md="6", :sm="12")
        el-form-item(label="比赛类型")
          el-select.sel-width(v-model="dataForm.projectType", clearable)
            el-option(label="单打", :value="1")
            el-option(label="双打", :value="2")
            //- el-option(label="年度总决赛" :value='4')
      el-col(:md="6", :sm="12")
        el-form-item(label="签位")
          el-input.sel-width(
            v-model="dataForm.applySize",
            clearable,
            placeholder="请输入签位数"
          )
            template(slot="suffix") 签位
    el-row(:span="24")
      el-col(:md="6", :sm="12")
        el-form-item(label="状态")
          el-select.matchStatus.sel-width(
            v-model="dataForm.matchStatus",
            clearable
          )
            el-option(label="未审核", value="1")
            el-option(label="已发布", value="2")
            el-option(label="报名中", value="6")
            el-option(label="报名结束", value="7")
            el-option(label="已开赛", value="8")
            el-option(label="已取消", value="3")
            el-option(label="已结束", value="4")
            el-option(label="已拒绝", value="5")
      el-col(:md="6", :sm="12")
        el-form-item(label="比赛时间")
          el-date-picker(
            style="width: 210px",
            v-model="dataForm.ctTime",
            range-separator="至",
            type="daterange",
            start-placeholder="开始日期",
            end-placeholder="结束日期",
            value-format="yyyy-MM-dd"
          )
      el-col(:md="6", :sm="12")
        el-form-item(label="比赛类别")
          el-select.sel-width(v-model="dataForm.matchType", clearable)
            el-option(label="单项赛", :value="3")
            el-option(label="团体赛", :value="4")

  el-row(style="padding-bottom: 15px", :span="24")
    //- el-col(:md='10' :sm="5")
    //-     el-button(@click='addOrUpdateHandle()' type='primary') 新建比赛
    el-col(:md="14", :sm="14", style="float: right")
      div(style="float: right; display: flex")
        el-button(
          @click="downloadContestants",
          type="primary",
          icon="el-icon-download"
        ) 批量导出参赛名单
        el-button(
          @click="getDataList()",
          type="primary",
          icon="el-icon-search",
          style="float: right; margin-right: %2"
        ) 查 询
  el-table(
    :data="tableData",
    style="width: 100%",
    v-loading="dataListLoading",
    border,
    @selection-change="selectionChangeHandle"
  )
    el-table-column(type="selection", width="50", align="center")
    el-table-column(
      prop="matchId",
      header-align="center",
      align="center",
      label="比赛ID",
      width="160"
    )
    el-table-column(
      prop="matchName",
      header-align="center",
      align="center",
      label="比赛名称",
      width="150"
    )
    el-table-column(
      prop="microOrgName",
      header-align="center",
      align="center",
      label="主办方"
    )
    el-table-column(
      prop="projectType",
      header-align="center",
      align="center",
      label="比赛类型",
      width="120"
    )
      template(slot-scope="scope")
        font(v-if="scope.row.projectType === 1") 单打
        font(v-if="scope.row.projectType === 2") 双打
        //- font(v-if='scope.row.ctType === 4') 年度总决赛
    el-table-column(
      prop="applySize",
      header-align="center",
      align="center",
      label="签位",
      width="60"
    )
      template(slot-scope="scope")
        span {{ scope.row.joinCount }}/{{ scope.row.applySize }}
    el-table-column(
      prop="level",
      header-align="center",
      align="center",
      label="比赛级别",
      width="60"
    )
      template(slot-scope="scope")
        span {{ scope.row.level.split(",")[0] }}~{{ scope.row.level.split(",")[1] }}
    el-table-column(
      prop="basisPoints",
      header-align="center",
      align="center",
      label="基础分"
    ) 
    el-table-column(
      prop="increasingPoints",
      header-align="center",
      align="center",
      label="递增分"
    )
    el-table-column(
      prop="rewardPoint",
      header-align="center",
      align="center",
      label="额外附加分"
    )
    el-table-column(
      prop="matchStartTime",
      header-align="center",
      align="center",
      label="比赛时间",
      width="160"
    )
    //- 7.15@lrq
    el-table-column(
      prop="matchStartTime",
      header-align="center",
      align="center",
      label="比赛类别",
      width="160"
    )
      template(slot-scope="scope")
        font(v-if="scope.row.matchType == 3")
          span
          span &nbsp; 单项赛
        font(v-if="scope.row.matchType == 4")
          span
          span &nbsp; 团体赛
    el-table-column(
      prop="payAmount",
      header-align="center",
      align="center",
      label="支付金额",
      width="160"
    ) 

    el-table-column(
      prop="payStatus",
      header-align="center",
      align="center",
      label="支付状态",
      width="160"
    )
      template(slot-scope="scope")
        font(v-if="scope.row.payStatus == 0")
          span
          span &nbsp; 未支付
        font(v-if="scope.row.payStatus == 1")
          span
          span &nbsp; 支付中
        font(v-if="scope.row.payStatus == 2")
          span
          span &nbsp; 支付成功
        font(v-if="scope.row.payStatus == 3")
          span
          span &nbsp; 支付失败
        font(v-if="scope.row.payStatus == 4")
          span
          span &nbsp; 超时
        font(v-if="scope.row.payStatus == 5")
          span
          span &nbsp; 申请退款
        font(v-if="scope.row.payStatus == 6")
          span
          span &nbsp; 退款中
        font(v-if="scope.row.payStatus == 7")
          span
          span &nbsp; 退款成功
        font(v-if="scope.row.payStatus == 8")
          span
          span &nbsp; 退款失败
        font(v-if="scope.row.payStatus == 9")
          span
          span &nbsp; 支付已关闭
        font(v-if="scope.row.payStatus == 10")
          span
          span &nbsp; 退款已取消
    el-table-column(
      prop="refundAmount",
      header-align="center",
      align="center",
      label="退款金额",
      width="160"
    )

    //- el-table-column(prop='refereeName',header-align='center',align='center',label='裁判' :show-overflow-tooltip='true')
    el-table-column(
      prop="matchStatus",
      header-align="center",
      align="center",
      label="状态",
      width="100"
    )
      template(slot-scope="scope")
        font(v-if="scope.row.matchStatus === 1")
          span.danger
          span &nbsp; 未审核
        font(
          v-if="scope.row.matchStatus === 2 && new Date(scope.row.matchSignStartTime).getTime() > new Date().getTime()"
        )
          span.success
          span &nbsp; 已发布
        font(
          v-if="scope.row.matchStatus === 2 && new Date(scope.row.matchSignStartTime).getTime() <= new Date().getTime() && new Date().getTime() <= new Date(scope.row.matchSignEndTime).getTime() && scope.row.joinCount < scope.row.applySize"
        )
          span.warning
          span &nbsp; 报名中
        font(
          v-if="scope.row.matchStatus === 2 && new Date(scope.row.matchSignStartTime).getTime() <= new Date().getTime() && new Date().getTime() <= new Date(scope.row.matchSignEndTime).getTime() && scope.row.joinCount >= scope.row.applySize"
        )
          span.warning
          span &nbsp; 已报满
        font(
          v-if="scope.row.matchStatus === 2 && new Date().getTime() > new Date(scope.row.matchSignEndTime).getTime() && new Date().getTime() < new Date(scope.row.matchStartTime).getTime()"
        )
          span.warning
          span &nbsp; 报名结束
        font(
          v-if="scope.row.matchStatus === 2 && new Date().getTime() > new Date(scope.row.matchStartTime).getTime()"
        )
          span.warning
          span &nbsp; 已开赛
        font(v-if="scope.row.matchStatus === 3")
          span.warning
          span &nbsp; 已取消
        font(v-if="scope.row.matchStatus === 4")
          span.warning
          span &nbsp; 已结束
        font(v-if="scope.row.matchStatus === 5")
          span.warning
          span &nbsp; 已拒绝
    el-table-column(
      prop="",
      header-align="center",
      align="center",
      label="操作",
      width="100"
    )
      template(slot-scope="scope")
        el-menu.menuPonit(:collapse="isCollapse")
          el-submenu(index="1")
            template(slot="title")
              i.el-icon-more(style="color: #02b90d")
            el-menu-item-group
              el-menu-item(
                index="1-1",
                @click="queryEdit(scope.row.id)",
                v-if="isAuth('ct:level:info')"
              ) 查看详情
              //- el-menu-item(index="1-2" @click="addOrUpdateHandle(scope.row.id,1)" v-if="isAuth('ct:level:update') && (scope.row.matchStatus === 1 || scope.row.matchStatus === 3 || scope.row.matchStatus === 5)"  type="text" ) 修改比赛
              el-menu-item(
                index="1-3",
                @click="releaseClick(1, scope.row)",
                v-if="isAuth('ct:level:apply') && (scope.row.matchStatus === 1 && scope.row.payStatus === 2 ) || scope.row.payStatus==null ",
                type="primary"
              ) 审核
              el-menu-item(
                index="1-4",
                @click="releaseClick(2, scope.row)",
                v-if="isAuth('ct:level:meber') && (scope.row.matchStatus === 2 || scope.row.matchStatus === 4)",
                type="primary"
              ) 查看参赛人员
              el-menu-item(
                index="1-6",
                @click="releaseClick(4, scope.row)",
                v-if="isAuth('ct:level:score') && (scope.row.matchStatus === 2 || scope.row.matchStatus === 4)",
                type="primary"
              ) 查看成绩
              el-menu-item(
                index="1-7",
                @click="releaseClick(9, scope.row)",
                type="primary",
                :disabled="scope.row.payStatus == 2? false : true", 
              ) 退费
              //- :disabled="scope.row.payStatus==7?true:false"

              //- el-menu-item(index="1-6" @click='releaseClick(8,scope.row)' v-if="isAuth('') && scope.row.matchStatus === 2" type='primary') 调整赛制
              //- el-menu-item(index="1-7" @click='releaseClick(6,scope.row)' v-if="isAuth('ct:level:out') && scope.row.matchStatus === 2" type='primary') 取消比赛
              //- el-menu-item(index="1-8" @click='releaseClick(7,scope.row)' v-if="isAuth('ct:level:over') && scope.row.matchStatus === 2" type='primary') 结束比赛
              //- el-menu-item(index="1-9" @click='releaseClick(5,scope.row)' v-if="isAuth('ct:level:copy')" type='primary') 复制并新建
  el-pagination(
    @size-change="sizeChangeHandle",
    @current-change="currentChangeHandle",
    :current-page="pageIndex",
    :page-sizes="[10, 20, 50, 100]",
    :page-size="pageSize",
    :total="totalPage",
    layout="total, sizes, prev, pager, next, jumper"
  )
  //添加和修改
  addOrUpdate(
    v-if="addOrUpdateVisible",
    ref="addOrUpdate",
    @refreshDataList="getDataList"
  )
  //查看和审核
  queryView(
    v-if="queryViewVisible",
    ref="queryView",
    @refreshDataList="getDataList"
  )
  //查看和审核
  verifyView(
    v-if="verifyViewVisible",
    ref="verifyView",
    @refreshDataList="getDataList"
  )
  //参数人员管理
  ElEnrollInfoOld(
    v-if="elEnrollInfoOldVisible",
    ref="elEnrollInfoOld",
    @refreshDataList="getDataList"
  )
  elEnrollInfo(
    v-if="elEnrollInfoVisible",
    ref="elEnrollInfo",
    @refreshDataList="getDataList"
  )
  //安排裁判
  updateReferee(
    v-if="updateRefereeVisible",
    ref="updateReferee",
    @refreshDataList="getDataList"
  )
  //成绩管理
  gradeInfo(
    v-if="gradeInfoVisible",
    ref="gradeInfo",
    @refreshDataList="getDataList"
  )
  gradeInfoOld(
    v-if="gradeInfoOldVisible",
    ref="gradeInfoOld",
    @refreshDataList="getDataList"
  )
    // 调整赛制
  adjustGameSys(
    v-if="adjustGameSysVisible",
    ref="adjustGame",
    @refreshDataList="getDataList"
  )
</template>

<script>
import table from "./table1.js";
import AddOrUpdate from "./add-or-update";
import QueryView from "./query-view";
import VerifyView from "./verify-view.vue";
import ElEnrollInfo from "./el-enroll-info";
import ElEnrollInfoOld from "./el-enroll-infoOld";
import UpdateReferee from "./update-referee";
import GradeInfo from "./grade-info";
import GradeInfoOld from "./grade-infoOld";
import AdjustGameSys from "./adjust-game-sys";
export default {
  data() {
    return {
      isCollapse: true,
      table: {
        columns: table.columns,
        data: null,
        size: "mini",
        stripe: true,
        border: true,
      },
      loading: null,
      gradeInfoVisible: false,
      gradeInfoOldVisible: false,
      updateRefereeVisible: false,
      addOrUpdateVisible: false,
      queryViewVisible: false,
      verifyViewVisible: false,
      elEnrollInfoVisible: false,
      elEnrollInfoOldVisible: false,
      adjustGameSysVisible: false,
      selChangeData: [],
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      restaurants: [],
      matchId: "",
      dataForm: {
        matchName: null,
        microOrgName: null,
        userGroupId: null,
        projectType: null,
        applySize: null,
        matchStatus: null,
        matchStartTime: [],
        matchType: null,
      },
      sysOrgList: [],
    };
  },
  components: {
    AddOrUpdate,
    QueryView,
    VerifyView,
    ElEnrollInfo,
    UpdateReferee,
    GradeInfo,
    AdjustGameSys,
    ElEnrollInfoOld,
    GradeInfoOld,
  },
  mounted() {
    this.matchId = this.$route.query.matchId;
    this.getDataList();
    //this.restaurants = this.loadAll()
    this.initCity();
  },
  methods: {
    //参赛人员管理
    enrollClick(rows) {
      console.log("rows", rows);
      //- 兼容旧数据newCompetition==1是新数据，反之是老数据
      if (rows.matchType == 3) {
        this.elEnrollInfoVisible = true;
        this.$nextTick(() => {
          this.$refs.elEnrollInfo.init(rows);
        });
      } else {
        this.elEnrollInfoOldVisible = true;
        this.$nextTick(() => {
          this.$refs.elEnrollInfoOld.init(rows);
        });
      }
    },
    //1:审核发布 2:设置参数人数
    releaseClick(type, rows) {
      if (
        type == 1 ||
        type == 2 ||
        type == 3 ||
        type == 4 ||
        type == 6 ||
        type == 7
      ) {
        //赛事状态: 1未审核，2已发布，3已取消，4已结束，5已拒绝
        //未发布的赛事可以审核发布、裁判设置、复制并新建
        if (rows.matchStatus === 1 && type != 1 && type != 3 && type != 5) {
          this.$message.error("比赛尚未发布!");
          return;
        }
        //若比赛处在未审核、已拒绝状态（即未发布），此处提示为比赛尚未发布，不能通过此操作取消比赛。
        //已拒绝的赛事可以审核发布、裁判设置、复制并新建
        if (rows.matchStatus === 5 && type != 1 && type != 3 && type != 5) {
          this.$message.error("比赛尚未发布!");
          return;
        }

        //已发布的赛事不能审核发布
        if (rows.matchStatus === 2 && type == 1) {
          this.$message.error("比赛已发布!");
          return;
        }
        //已取消的比赛可以复制并新建
        if (rows.matchStatus === 3 && type != 5) {
          this.$message.error("比赛已取消!");
          return;
        }
        //已结束的比赛可以录入成绩
        if (rows.matchStatus === 4 && type != 2 && type != 4) {
          this.$message.error("比赛已结束!");
          return;
        }
      }
      //审核发布
      if (type == 1) {
        this.queryHandle(rows, "release");
        return;
      }
      //设置参赛人员
      if (type == 2) {
        this.enrollClick(rows);
      }
      //安排裁判
      if (type == 3) {
        this.updateRefereeVisible = true;
        this.$nextTick(() => {
          this.$refs.updateReferee.init(rows);
        });
      }
      //成绩管理
      if (type == 4) {
        //报名结束、已开赛、已结束状态的比赛才可以进行成绩录入，否则名单显示不完整。
        if (rows.matchStatus === 2 || rows.matchStatus === 4) {
          let date1 = new Date();
          let date3 = new Date(rows.matchSignEndTime);
          if (date3.getTime() > date1.getTime()) {
            this.$message.error("报名尚未结束!");
            return;
          }
          //单打
          //- 兼容旧数据newCompetition==1是新数据，反之是老数据
          if (rows.matchType == 3) {
            this.gradeInfoVisible = true;
            this.$nextTick(() => {
              this.$refs.gradeInfo.init(rows, -1);
            });
          } else {
            this.gradeInfoOldVisible = true;
            this.$nextTick(() => {
              this.$refs.gradeInfoOld.init(rows, -1);
            });
          }

          // this.gradeInfoVisible = true
          // this.$nextTick(() => {
          //   this.$refs.gradeInfo.init(rows, -1)
          // })
        }
        return;
      }
      //复制新建
      if (type == 5) {
        this.openFullScreen();
        console.log(rows.id);
        this.$http({
          url: this.$http.adornUrl(`/ctCompetition/copyAdd/` + rows.id),
          method: "post",
        }).then((data) => {
          // if (data && data.code === 0) {
          //   this.getDataList();
          //   this.$message.success("操作成功!");
          // } else {
          //   this.$message.error("添加失败!");
          // }
          this.loading.close();
          this.addOrUpdateHandle(data.id, 2);
        });
      }
      //取消比赛
      if (type == 6) {
        this.$http({
          url: this.$http.adornUrl(`/elEnrollOrder/getByCtId`),
          method: "post",
          params: this.$http.adornParams({
            ctId: rows.id,
          }),
        }).then((data) => {
          if (data && data.code === 0) {
            var flag = true;
            for (let i of data.list) {
              if (
                i.payStatus == 2 ||
                i.payStatus == 5 ||
                i.payStatus == 6 ||
                i.payStatus == 10
              ) {
                this.$message.error("请先完成退费操作!");
                flag = false;
                return;
              }
            }
            if (flag) {
              let info = "是否取消比赛？";
              if (data.prePay) {
                info = "是否取消比赛，并退回加盟费至原账户？";
              }
              this.$confirm(info, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(async () => {
                  this.$http({
                    url: this.$http.adornUrl(
                      `/ctCompetition/cancelCompetition`
                    ),
                    method: "post",
                    data: rows,
                  }).then((data) => {
                    console.log("data:", data);
                    if (data && data.code === 0) {
                      if (data.state) {
                        this.getDataList();
                        this.$message.success("比赛已取消");
                      } else {
                        this.$message.error(data.info);
                      }
                    }
                  });
                })
                .catch(() => {
                  this.$message.info("已取消");
                });
            }
          }
        });
      }
      if (type == 7) {
        console.log("结束比赛操作");
        //结束比赛
        let date1 = new Date();
        let date2 = new Date(rows.matchStartTime);
        if (date2.getTime() > date1.getTime()) {
          this.$message.error("比赛尚未开始!");
          return;
        }
        //若比赛处在已开赛状态，且未完成成绩录入（即成绩录入表中存在空值），则提示尚未录入成绩，不能通过此操作结束比赛。
        this.$http({
          url: this.$http.adornUrl(`/elEnroll/getByCtId`),
          method: "post",
          params: this.$http.adornParams({
            ctId: rows.id,
          }),
        }).then((data) => {
          if (data.elEnrollNum == data.ctScoreNum) {
            this.$confirm("是否结束比赛？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(async () => {
                this.$http({
                  url: this.$http.adornUrl(`/ctCompetition/endCompetition`),
                  method: "post",
                  data: rows,
                }).then((data) => {
                  if (data && data.code === 0) {
                    this.getDataList();
                    this.$message.success("操作成功");
                  }
                });
              })
              .catch(() => {
                this.$message.info("操作取消");
              });
          } else {
            this.$message.error("尚未录入成绩，不能通过此操作结束比赛");
          }
        });
      }
      // 调整赛制
      if (type === 8) {
        this.adjustGameSysVisible = true;
        this.$nextTick(() => {
          this.$refs.adjustGame.init(rows);
        });
      }
      // 退费
      if (type === 9 && rows.payStatus == 2) {
        let tips = "是否对该比赛进行退款？";
        this.$confirm(tips, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            console.log(123);
            let refundParams = {
              orderId: rows.orderId, //订单id
            };

            this.$http({
              url: this.$http.adornUrl(`/payRefund/selfRefund`),
              method: "post",
              data: refundParams,
            }).then((data) => {
              if (data && data.code === 0) {
                this.$message.success("操作成功！");
                rows.payStatus = 6;
                // this.refundVisible = false;
                // this.refundBtn = false;
                // this.getEnrollData(this.ruleForm.id);
              }
            });
          })
          .catch(() => {});
      }
    },
    // 缓存
    openFullScreen() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    //查看和审核发布
    queryEdit(id, type) {
      this.queryViewVisible = true;
      this.$nextTick(() => {
        this.$refs.queryView.init(id, type);
      });
    },
    queryHandle(row, type) {
      this.verifyViewVisible = true;
      this.$nextTick(() => {
        this.$refs.verifyView.init(row, type);
      });
    },
    //添加或修改事件
    addOrUpdateHandle(id, type) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, type);
      });
    },
    getDataList() {
      let _this=this
      _this.dataListLoading = true;
      let ctStrTime = null;
      let ctEndTime = null;
      if (_this.dataForm.matchStartTime !== null) {
        if (_this.dataForm.matchStartTime.length > 0) {
          ctStrTime = _this.dataForm.matchStartTime[0];
          ctEndTime = _this.dataForm.matchStartTime[1];
        }
      }
      _this.tableData=[]
      _this.$http({
        url: this.$http.adornUrl("/ctCompetition/list"),
        method: "post",
        params: _this.$http.adornParams({
          page: _this.pageIndex,
          rows: _this.pageSize,
          matchType: _this.dataForm.matchType||null,
          matchName: _this.dataForm.matchName,
          microOrgName: _this.dataForm.microOrgName,
          userGroupId: _this.dataForm.userGroupId || null,
          projectType: _this.dataForm.projectType || null,
          applySize: _this.dataForm.applySize || null,
          matchStatus: _this.dataForm.matchStatus || null,
          ctStrTime: ctStrTime,
          ctEndTime: ctEndTime,
          matchId: _this.matchId,
        }),
      }).then((data) => {
        if (data && data.code === 0) {
          _this.tableData = data.page.rows;
          _this.totalPage = data.page.total;
        } else {
          _this.tableData = [];
          _this.totalPage = 0;
        }
        _this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    querySearchDrewOrder(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    // loadAll() {
    //     return [
    //         { value: "2签位" },
    //         { value: "4签位" },
    //         { value: "8签位" },
    //         { value: "16签位" },
    //         { value: "64签位" },
    //         { value: "128签位" }
    //     ];
    // },
    initCity() {
      this.$http({
        url: this.$http.adornUrl("/sysOrg/list"),
        method: "get",
      }).then((data) => {
        this.sysOrgList = data && data.code === 0 ? data.list : [];
      });
    },
    //勾选列表事件
    selectionChangeHandle(val) {
      let choseVal = [];
      // val.
      val.forEach((item) => {
        let arr = {
          ctId: item.id,
          // clubName: null
        };
        choseVal.push(arr);
      });
      this.selChangeData = choseVal;
    },
    // 批量导出参赛名单
    downloadContestants() {
      if (this.selChangeData == null || this.selChangeData.length === 0) {
        this.$message.info("没有要导出的数据!");
        return;
      }
      const beans = [];
      console.log(this.selChangeData);
      this.$http({
        url: this.$http.adornUrl(`/elEnrollOrder/getCompExportList`),
        method: "post",
        data: this.selChangeData,
      }).then((data) => {
        let arr = data.list;
        if (arr.length === 0) {
          return this.$message.info("没有参赛人员输出!");
        }
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].matchType == -1) {
            arr[i].matchType = " 青少年比赛";
          } else if (arr[i].matchType == 1) {
            arr[i].matchType = " 分级公开赛";
          } else if (arr[i].matchType == 2) {
            arr[i].matchType = " 俱乐部比赛";
          }
          if (arr[i].gender == 0) {
            arr[i].gender = " 男";
          } else if (arr[i].gender == 1) {
            arr[i].gender = " 女";
          }
          if (arr[i].type == 1) {
            arr[i].type = " 注册会员";
          } else if (arr[i].type == 2) {
            arr[i].type = " 初级会员";
          } else if (arr[i].type == 3) {
            arr[i].type = " 荣誉会员";
          }
          if (arr[i].isSixth == 0) {
            arr[i].isSixth = "无";
          } else if (arr[i].isSixth == 1) {
            arr[i].isSixth = "有";
          }
          if (arr[i].clubScore == null) {
            arr[i].clubScore = 0;
          }
        }
        console.log(arr);
        this.$export
          .excel({
            columns: this.table.columns,
            data: arr,
            title: "俱乐部公开赛参赛名单",
          })
          .then(() => {
            this.$message.success("导出表格成功");
          });
      });
    },
  },
};
</script>
<style>
/* 操作三点 菜单样式 */
@import "../../../css/opr3dot.css";

.sel-width {
  width: 200px;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}
</style>
